import { extendTheme } from "@chakra-ui/react";

const overrides = extendTheme({
  styles: {
    global: (props) => ({
      body: {
        fontFamily: '"DM Sans", "Inter", sans-serif"',
      },
    }),
  },
});

const AppTheme = extendTheme(overrides);

export default AppTheme;
